<div class="account-menu">
  <button class="account-menu__toggle" (click)="toggle()" type="button">
    <sgt-avatar [settings]="avatarSettings"></sgt-avatar>
    <div class="account-menu__user-summary">
      <span class="account-menu__summary-name">{{ user?.name }}</span>
      <span class="account-menu__summary-perfil" *ngIf="userPerfil">{{
        userPerfil
      }}</span>
    </div>
  </button>

  <div class="account-menu__dropdown" *ngIf="isOpen">
    <div class="account-menu__header">
      <sgt-avatar [settings]="avatarSettings"></sgt-avatar>
      <div class="account-menu__user-info">
        <span class="account-menu__user-name">{{ user.name }}</span>
        <span class="account-menu__user-email">{{ user.email }}</span>
        <span class="account-menu__company-name" *ngIf="user.companyName">
          <i class="far fa-building"></i> {{ user.companyName }}
        </span>
      </div>
    </div>

    <div class="account-menu__divider"></div>

    <nav>
      <ng-container *ngFor="let item of menuItems">
        <a
          *ngIf="item.visible !== false && item.routerLink"
          class="account-menu__item"
          [routerLink]="item.routerLink"
          (click)="onMenuItemClick(item)"
        >
          <i class="account-menu__item-icon fas {{ item.icon }}"></i>
          <span class="account-menu__item-label">{{ item.label }}</span>
        </a>
        <button
          *ngIf="item.visible !== false && !item.routerLink"
          class="account-menu__item"
          type="button"
          (click)="onMenuItemClick(item)"
        >
          <i class="account-menu__item-icon fas {{ item.icon }}"></i>
          <span class="account-menu__item-label">{{ item.label }}</span>
        </button>
      </ng-container>
    </nav>

    <div class="account-menu__divider"></div>

    <button
      class="account-menu__item account-menu__item--logout"
      type="button"
      (click)="onLogout()"
    >
      <i class="account-menu__item-icon fas fa-sign-out-alt"></i>
      <span class="account-menu__item-label">Sair</span>
    </button>
  </div>
</div>

<sgt-usuario-altera-senha-modal
  #alteraSenhaModal
  idModal="alteraSenhaModal"
></sgt-usuario-altera-senha-modal>
